import order from "@/pages/order/order";
import orderFastener from "@/pages/order/orderFastener";
import orderDeposit from "@/pages/order/orderDeposit";
import orderDetail from "@/pages/order/order-detail";
import completeStock from "@/pages/order/completeStock";
import stockList from "@/pages/order/stockList";
import dayStockList from "@/pages/order/day-stock-list";
import shippingList from "@/pages/order/shippingList";
import deliverySheet from "@/pages/order/delivery-sheet";
import scanningStock from "@/pages/order/scanningStock";
import prinPurchase from "@/pages/order/prinPurchase";
import QuickSetBoxNum from "@/pages/order/quick-set-box-num";
import inputTS from "@/pages/order/input-ts";
import matchRefuse from "@/pages/order/matchRefuse";
import test from "@/pages/test";
import reporting from "@/pages/orderReport/reportCenter";
import reportCreate from "@/pages/orderReport/reportCenter/create";
import layout from "@/components/layout/layout";
import bigorder from "./bigorder";
const orderRouter = {
  path: "/order",
  component: layout,
  meta: {
    roles: ["shop", "r4gys"],
    title: "订单管理",
    icon: "icon-jichushezhi"
  },
  children: [
    {
      path: "/order/manage",
      component: order,
      name: "order",
      meta: {
        roles: ["pingtai", "zhifa", "factory", "r4gys"],
        title: "三方备货出库单"
      }
    },
    {
      path: "/order/manageFastener",
      component: orderFastener,
      name: "orderFastener",
      meta: { roles: ["jgj"], title: "待处理订单" } // 紧固件才显示
    },
    {
      path: "/order/deposit",
      component: orderDeposit,
      name: "orderDeposit",
      meta: {
        roles: ["is_deposit"],
        title: "618定金单"
      }
    },
    {
      path: "/order/edit/",
      component: orderDetail,
      name: "orderDetail",
      hidden: true,
      meta: { roles: ["shop", "r4gys"] }
    },
    {
      path: "/order/completeStock",
      component: completeStock,
      name: "completeStock",
      hidden: true,
      meta: { roles: ["shop", "r4gys"] }
    },
    {
      path: "/order/test",
      name: "test",
      hidden: true,
      component: test,
      meta: { roles: ["shop", "r4gys"] }
    },
    {
      path: "/order/storeList",
      name: "storeList",
      hidden: true,
      component: stockList,
      meta: { roles: ["shop", "r4gys"] }
    },
    {
      path: "/order/shippingList",
      name: "shippingList",
      hidden: true,
      component: shippingList,
      meta: { roles: ["shop", "r4gys"] }
    },
    {
      path: "/order/scanningStock",
      name: "scanningStock",
      hidden: true,
      component: scanningStock,
      meta: { roles: ["shop", "r4gys"] }
    },
    {
      path: "/order/dayStockList",
      name: "dayStockList",
      hidden: true,
      component: dayStockList,
      meta: { roles: ["shop", "r4gys"] }
    },
    {
      path: "/order/deliverySheet",
      name: "deliverySheet",
      hidden: true,
      component: deliverySheet,
      meta: { roles: ["shop", "r4gys"] }
    },
    {
      path: "/order/prinPurchase",
      name: "prinPurchase",
      hidden: true,
      component: prinPurchase,
      meta: { roles: ["shop", "r4gys"] }
    },
    {
      path: "/order/QuickSetBoxNum",
      name: "QuickSetBoxNum",
      hidden: true,
      component: QuickSetBoxNum,
      meta: { roles: ["shop", "r4gys"], title: "快速打包" }
    },
    {
      path: "/order/inputTS",
      name: "inputTS",
      hidden: true,
      component: inputTS,
      meta: { roles: ["shop", "r4gys"], title: "录入物流运单" }
    },
    // 自配拒收单 2022-05-09
    {
      path: "/order/matchRefuse",
      name: "matchRefuse",
      hidden: true,
      component: matchRefuse,
      meta: { roles: ["shop", "r4gys"], title: "自配拒收单" }
    },
    ...bigorder,
    {
      path: "/orderReport/reporting",
      component: reporting,
      name: "reporting",
      meta: { roles: ["shop", "r4gys"], title: "异常订单" }
    },
    {
      path: "/orderReport/reporting/create",
      component: reportCreate,
      name: "reportCreate",
      hidden: true,
      meta: { roles: ["shop", "r4gys"], title: "创建订单报备" }
    }
  ]
};
export default orderRouter;



// WEBPACK FOOTER //
// ./src/router/modules/orderRouter.js